import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_FlowchartPaper_Button_Interface, FlowchartPaper_Button_Interface } from 'src/app/Interface/FlowchartPaper_Button_Interface';
import { Empty_FlowchartPaper_History_Interface, FlowchartPaper_History_Interface } from 'src/app/Interface/FlowchartPaper_History_Interface';
import { Empty_FlowchartPaper_Interface, FlowchartPaper_Interface } from 'src/app/Interface/FlowchartPaper_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { FlowcharPaperService } from 'src/app/Service/Flowchart/FlowcharPaper.service';
import { FlowchartService } from 'src/app/Service/Flowchart/Flowchart.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-FlowchartArchive',
  templateUrl: './FlowchartArchive.component.html',
  styleUrls: ['./FlowchartArchive.component.scss']
})
export class FlowchartArchiveComponent implements OnInit {

  Token: String = ""
  PaperDsc: string = ""
  page: number = 0;
  Procssing: boolean = false
  ProcssingAction: boolean = false
  SubmitPeriodDate:string='1'
  Form_Filter:string='0'
  BaseUrl1:string=""
  LetterNumber_Filter:string=""
  Fullname_Filter:string=""
  BaseUrlCo:string="&id2="

  modalRef_Action: any;

  constructor(
    private FlowcharPaper_Service: FlowcharPaperService,
    private Flowchart_Service: FlowchartService,
    private Nav_Service: NavService,

  ) { }

  DataList_Paper: Array<FlowchartPaper_Interface> = []
  DataList_Form: Array<General_Interface> = []

  Data_Seleted_Record: FlowchartPaper_Interface = Empty_FlowchartPaper_Interface()
  Data_Seleted_Button: FlowchartPaper_Button_Interface = Empty_FlowchartPaper_Button_Interface()

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.BaseUrl1 =  environment.BaseUrl+"flowchart/WorkflowDetail?token="+this.Token+"&id="
    this.Nav_Service.CheckValidPage(this.Token, 2203).subscribe(
      data => {
        this.ReadData_Form()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_Form() {
    this.Procssing = true
    this.Flowchart_Service.GetForm(this.Token,).subscribe(
      data => {
        this.DataList_Form = data
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  ReadData_Paper(StartSearchDate, EndSearchDate) {
    this.Procssing = true
    this.FlowcharPaper_Service.Read_archive(this.Token,
      this.LetterNumber_Filter,
      StartSearchDate,
      EndSearchDate,
      Number(this.SubmitPeriodDate),
      Number(this.Form_Filter)).subscribe(
      data => {
        this.DataList_Paper = data
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  Set_Data_Seleted_Record(item:FlowchartPaper_Interface)
  {
    this.Data_Seleted_Record=item
  }

  Reset_Data_Seleted_Record(){
    this.Data_Seleted_Record = Empty_FlowchartPaper_Interface()
  }

  DataList_History:Array<FlowchartPaper_History_Interface>=[]
  Selected_History_Record:  FlowchartPaper_Interface=Empty_FlowchartPaper_Interface();
  ReadData_History(item:FlowchartPaper_Interface){
    this.Procssing=true
    this.FlowcharPaper_Service.History_WorkFlow(this.Token,item.makerId).subscribe(
      data=>{
        this.Selected_History_Record=item
        this.DataList_History=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Close_Show_History(){
    this.Selected_History_Record=Empty_FlowchartPaper_Interface()
  }
}
